<ng-template #loaderBlock>
  <app-loader></app-loader>  
</ng-template>
<div class="risk-management-wrapper">
  <table>
    <thead>
      <tr>
        <th *ngFor="let head of headerList">
          <label>
            {{ head?.label }}
          </label>
        </th>
      </tr>
    </thead>
    <tbody>
      <ng-container>
        <ng-container *ngIf="riskManagement?.length; else noDataBlock">
          <tr *ngFor="let data of riskManagement">
            <td><span [title]="data.risk">{{ data.risk }}</span></td>
            <td>{{ data.engagementName }}</td>
            <td>
              <div
                class="severity"
                [ngClass]="{
                  high: data.severity == '1',
                  medium: data.severity == '2',
                  low: data.severity == '3'
                }"
              >
                {{ data?.severityText }}
              </div>
            </td>
            <td>
              <div class="owner">
                <motif-avatar
                  size="medium"
                  [userName]="data.owner"
                  [src]="data.baseImg"
                ></motif-avatar>
                <label>{{ data.owner }}</label>
              </div>
            </td>
            <td>
              <span [title]="data.mitigationPlan">{{ data.mitigationPlan }}</span>
            </td>
          </tr>
        </ng-container>
        <ng-template #noDataBlock>
          <!-- <tr class="loader">
            <td colspan="6">
              <app-no-data></app-no-data>
            </td>
          </tr> -->
        </ng-template>
      </ng-container>
    </tbody>
  </table>
  <ng-template>
  </ng-template> 
  <!-- <div class="risk-management-footer">
    <div class="view-all">View All</div>
  </div> -->
  <ng-container *ngIf="!loading; else loaderBlock"> </ng-container>
</div>
